import React, { useEffect, useState, useRef } from "react";
import cssClasses from "./Leads.module.css";
import CustomInput from "../../Subcomponents/CustomInput";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import DropDown from "../../Subcomponents/DropDown";
import SearchBar from "../../Subcomponents/Search";
import ThreeDotsMenu from "../../Subcomponents/ThreeDotsMenu";
import LeadCard from "./../../Subcomponents/userCard/LeadCard";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import action from "../../Redux Store/actions";
import PlusIcon from "../Icons/PlusIcon";
import { DataGrid } from "@mui/x-data-grid";
import Dot from "../Icons/Dot";
import WhatsApp from "../Icons/WhatsApp";
import AddLead from "../../Modals/AddLead/AddLead";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import debounce from "lodash.debounce";
//SERVICE
import {
  getLeads,
  getLeadsStatus,
  getProjects,
  getUsers,
} from "../../Services/LeadService";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { errorTost, offlineToast } from "../../Services/Toast";
import { Network } from "@capacitor/network";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import checked from "../../Assets/Images/checked.svg";
import DateComponent from "../../Subcomponents/DateComponent";
import { handleErrors } from "../../Services/LoginService";

import InfiniteScroll from "react-infinite-scroll-component";
// Icons
import EmptyListIcon from "../../Assets/Images/EmptyDataIcons/Group26795.svg";
import { uniqBy } from "lodash";

export default function Leads() {
  const dispatch = useDispatch();
  const [addLeadModal, setAddLeadModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [hideAddLead, setHideLead] = useState(false);
  const [search, setSearch] = useState("");
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState("Latest First");
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [count, setCount] = useState(0);
  //sort by
  const [showDropDown, setShowDropDown] = useState(false);
  const [listOfDropDown, setListOfDropDown] = useState([
    { label: "None", select: true },
    { label: "Date", select: false },
    { label: "Sales", select: false },
    { label: "Project", select: false },
    { label: "Status", select: false },
  ]);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [salescheckBox, setSalesCheckbox] = useState([]);
  const [showSalesValues, setShowSalesValues] = useState(false);
  const [projectcheckBox, setProjectCheckbox] = useState([]);
  const [showprojectValues, setShowprojectValues] = useState(false);
  const [statuscheckBox, setStatusCheckbox] = useState([
    { label: "Unclaimed", value: false },
        { label: "Claimed", value: false },
        { label: "Site Visit Scheduled", values: false },
        { label: "Site Visit Done", values: false },
        { label: "Token Payment Pending", value: false },
        { label: "Token Payment Complete", values: false },
        { label: "Token Partial Payment Done", values: false },
        { label: "Checkpoint One Cleared", values: false },
        { label: "Checkpoint Two Cleared", values: false },
        { label: "Token Refund Requested", values: false },
        { label: "Token Refunded", values: false },
        { label: "Token Refund Request Rejected", values: false },
        { label: "Allotment Payment Complete", value: false },
        { label: "Allotment Payment Pending", values: false },
        { label: "Allotment Partial Payment Done", values: false },
        { label: "PreSelect Payment Pending", values: false },
        { label: "Preselect not confirmed", values: false },
        { label: "PreSelect Unit on Hold", values: false },
        { label: "Preselect payment not done", values: false },
        { label: "PreSelect Partial Payment Done", values: false },
        { label: "PreSelect Confirmation Pending", values: false },
        { label: "Cancellation Confirmation Pending", values: false },
        { label: "Cancel Unit Done", values: false },
        { label: "Cancel Unit Not Done", values: false },
        { label: "Unit on Hold", values: false },
        { label: "Closed", values: false },
  ]);
  const [showStatusValues, setShowStatusValues] = useState(false);
  const [selectDates, setSelectDates] = useState([
    { label: "StartDate", value: "" },
    { label: "EndDate", value: "" },
  ]);
  //selected Values
  const [selectedDates, setSelectedDate] = useState(null);
  const [selectedSales, setSelectedSales] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const [showDates, setShowDates] = useState(false);
  const [leadsPresent, setLeadsPresent] = useState(null);
  const navigate = useNavigate();
  const [AllLeads, setAllLeads] = useState([]);
  const [helperText, setHelperText] = useState({
    startDate: "",
    endDate: "",
  });
  const [storedData, setStoredData] = useState(false);
  useEffect(() => {
    dispatch(action.activeMenu("leads"));
    if (loggedInUser.cpType === "Entity") {
      setHideLead(true);
    }
    getAllProjects();
    getAllUsers();
  }, []);

  useEffect(() => {
    setPageNumber(0);
    setLoadingStatus(0);
    setAllLeads([]);
    if (document.getElementById("scrollableDiv")) {
      document.getElementById("scrollableDiv").scrollTop = 0;
    }
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllLeads(
          0,
          selectedSales,
          selectedProjects,
          selectedStatus,
          selectDates,
          selectedDates,
          search,
          drpDownSelectedVal
        );
      } else {
        offlineToast();
      }
    });
  }, []);

  function getAllLeads(
    _pageNumber,
    selectedSales,
    selectedProjects,
    selectedStatus,
    selectDates,
    selectedDates,
    _search,
    _drpDownSelectedVal
  ) {
    _pageNumber = _pageNumber ? _pageNumber : 0;
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeads(
          loggedInUser?.cpId,
          loggedInUser?.fosId,
          _pageNumber * pageSize,
          _pageNumber * pageSize + pageSize - 1,
          selectedSales,
          selectedProjects,
          selectedStatus,
          selectDates,
          selectedDates,
          _search,
          _drpDownSelectedVal
        )
          .then((resp) => {
            console.log(resp);
            setCount(resp.count);
            if (resp.count > 0) {
              setLeadsPresent(true);
            } else {
              setLeadsPresent(false);
            }
            if (resp.count > resp.data.length) {
              setLoadingStatus(0);
              setPageNumber(1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            console.log(resp);
            dismissLoader();
            resp.data = resp.data.map((el, index) => ({
              ...el,
              id: index,
              leadId: el?.id,
              personName: el?.leadname,
              email: el?.leademail ?? "-",
              phoneNumber: el?.leadcontactnumber ?? "-",
              status: el?.leadstatus ?? "-",
              FOS: el?.fosname ?? "-",
              leadDisplayId: el?.leaddisplayid ?? "-",
            }));
            setAllLeads([...resp.data]);
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
            handleErrors(err, "getLeads");
          });
        dismissLoader();
      } else {
        offlineToast();
      }
    });
  }
  function getMoreData() {
    console.log("pageNumber", pageNumber);
    console.log("loadingStatus =>", loadingStatus);
    if (loadingStatus !== 0) return;
    setLoadingStatus(1);
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeads(
          loggedInUser.cpId,
          loggedInUser.fosId,
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          selectedSales,
          selectedProjects,
          selectedStatus,
          selectDates,
          selectedDates,
          search,
          drpDownSelectedVal
        )
          .then((resp) => {
            dismissLoader();
            console.log(resp);
            if (resp.count > resp.data.length + AllLeads.length) {
              setLoadingStatus(0);
              setPageNumber(pageNumber + 1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            setCount(resp.count);
            resp.data = resp.data.map((el, index) => ({
              ...el,
              id: index,
              personName: el?.leadname,
              email: el?.leademail ?? "-",
              leadId: el?.id,
              phoneNumber: el?.leadcontactnumber ?? "-",
              status: el?.leadstatus ?? "-",
              FOS: el?.fosname ?? "-",
              leadDisplayId: el?.leaddisplayid ?? "-",
            }));
            setAllLeads((pre) => [...pre, ...resp.data]);
          })
          .catch((err) => {
            dismissLoader();
            console.log(err);
            handleErrors(err, "scroll-get-Leads");
          });
        setLoadingStatus(0);
      } else {
        offlineToast();
      }
    });
  }
  function refreshLeads() {
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllLeads(
          0,
          selectedSales,
          selectedProjects,
          selectedStatus,
          selectDates,
          selectedDates,
          search,
          drpDownSelectedVal
        );
      } else {
        offlineToast();
      }
    });
  }
  function leadAdded(respValue) {
    if (respValue) {
      clearFilters();
      setAllLeads([]);
      setPageNumber(0);
      document.getElementById("input-with-icon-textfield leadSearch").value =
        "";
      setSearch("");
      setTimeout(() => {
        Network.getStatus().then((status) => {
          if (status.connected) {
            getAllLeads(0, [], [], [], selectDates, null, "", "Latest First");
          } else {
            offlineToast();
          }
        });
      }, 100);
    }
  }
  function buttonResp(respValue) {
    if (respValue) {
      clearFilters();
      setAllLeads([]);
      setPageNumber(0);
      document.getElementById("input-with-icon-textfield leadSearch").value =
        "";
      setSearch("");
      setTimeout(() => {
        Network.getStatus().then((status) => {
          if (status.connected) {
            getAllLeads(0, [], [], [], selectDates, null, "", "Latest First");
          } else {
            offlineToast();
          }
        });
      }, 100);
    }
  }
  function clearFilters() {
    setSelectedListDropDown([]);
    setListOfDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        select: false,
      }));
      pre[0].select = true;
      return [...pre];
    });
    if (selectDates.startDate === "" || selectDates.endDate === "") {
      setListOfDropDown((pre) => {
        pre[1].select = false;
        return [...pre];
      });
    }
    salescheckBox.forEach((el) => {
      el.value = false;

      setListOfDropDown((pre) => {
        pre[2].select = false;
        return [...pre];
      });
    });
    projectcheckBox.forEach((el) => {
      el.value = false;

      setListOfDropDown((pre) => {
        pre[3].select = false;
        return [...pre];
      });
    });
    statuscheckBox.forEach((el) => {
      el.value = false;

      setListOfDropDown((pre) => {
        pre[4].select = false;
        return [...pre];
      });
    });
    setShowSalesValues(false);
    setShowDates(false);
    setShowprojectValues(false);
    setShowStatusValues(false);
    setSelectedSales([]);
    setSelectedProjects([]);
    setSelectedStatus([]);
    setSelectedDate(null);
    setSelectDates((pre) => {
      pre[0].value = "";
      pre[1].value = "";
      return { ...pre };
    });
  }
  const debouncedFetchSearchData = debounce((e) => {
    setSearch(e.target.value);
    Network.getStatus().then((status) => {
      if (status.connected) {
        getAllLeads(
          0,
          selectedSales,
          selectedProjects,
          selectedStatus,
          selectDates,
          selectedDates,
          e.target.value,
          drpDownSelectedVal
        );
      } else {
        offlineToast();
      }
    });
  }, 800);
  //filters
  function getAllProjects() {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        // getProjects()
        //   .then((resp) => {
        //     let tempArray = projectcheckBox;
        //     tempArray = resp.map((el, index) => {
        //       return {
        //         label: el.projectName,
        //         value: false,
        //         id: el.projectId,
        //       };
        //     });
        //     setProjectCheckbox(tempArray);
        //   })
        //   .catch((err) => {
        //     handleErrors(err, "getAllProjects");
        //   });
        
      } else {
        offlineToast();
      }
    });
  }
  function getAllUsers() {
    Network.getStatus().then((resp) => {
      if (resp.connected) {
        getUsers()
          .then((resp) => {
            let tempArray = salescheckBox;
            tempArray = resp.map((el, index) => {
              return {
                label: el.name,
                value: false,
                id: el.userId,
              };
            });
            setSalesCheckbox(tempArray);
          })
          .catch((err) => {
            handleErrors(err, "getAllUsers");
          });
      } else {
        offlineToast();
      }
    });
  }
  return (
    <div className={cssClasses.wrapperPage}>
      <div className={cssClasses.wrapperHeader}>
        <div>
          <div className={cssClasses.headerTitle}>Leads</div>
          <div className={cssClasses.headerSubTitle}>
            Manage your Leads here.
          </div>
        </div>
        {hideAddLead === false && (
          <div>
            <Button
              style={{
                color: "#fff",
                backgroundColor: "#175CD3",
                fontSize: "1.6rem",
                lineHeight: "2.4rem",
              }}
              btnName={"Add Leads"}
              clicked={() => {
                setAddLeadModal(true);
              }}
              btnIcon={<PlusIcon />}
              iconPosition={"left"}
            />
          </div>
        )}
      </div>
      <div className={cssClasses.wrapperFilters}>
        <div className={cssClasses.wrapperNameDropDown}>
          <div className={cssClasses.allLeadsTitle}>{count} Leads </div>
          <div className={cssClasses.wrapperFilter}>
            {/* <div className={cssClasses.filterTitle}>Filter by</div> */}
            <div className={cssClasses.wrapperDropDown}>
              <div
                className={cssClasses.wrapperCustomiseDropDown}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropDown(!showDropDown);
                }}
              >
                <div className={cssClasses.dropDownLabel}>
                  <span className={cssClasses.dropDownLabelValue}>
                    {selectedListDropDown.join()}
                  </span>
                  {selectedListDropDown.length === 0 && (
                    <span className={cssClasses.dropDownLabelValue}>None</span>
                  )}
                </div>
                {showDropDown && (
                  <KeyboardArrowUpIcon className={cssClasses.dropDownIcon} />
                )}
                {showDropDown === false && (
                  <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
                )}
              </div>
              {showDropDown && (
                <ClickAwayListener
                  onClickAway={() => {
                    setShowDropDown(false);
                  }}
                >
                  <div className={cssClasses.containerCustomiseDropDown}>
                    <div className={cssClasses.wrapperSelectAndCheckbox}>
                      <div className={cssClasses.wrapperEachSelect}>
                        {listOfDropDown.map((each, index) => {
                          return (
                            <div
                              className={
                                each.select
                                  ? cssClasses.selectedVal
                                  : cssClasses.containerEachSelect
                              }
                            >
                              <div
                                className={cssClasses.eachSelect}
                                onClick={() => {
                                  setListOfDropDown((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      select: false,
                                    }));
                                    // pre[index].select = true;
                                    return [...pre];
                                  });
                                  if (
                                    selectDates.startDate === "" ||
                                    selectDates.endDate === ""
                                  ) {
                                    setListOfDropDown((pre) => {
                                      pre[1].select = true;
                                      return [...pre];
                                    });
                                  }
                                  salescheckBox.forEach((el) => {
                                    if (el.value) {
                                      setListOfDropDown((pre) => {
                                        pre[2].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  projectcheckBox.forEach((el) => {
                                    if (el.value) {
                                      setListOfDropDown((pre) => {
                                        pre[3].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  statuscheckBox.forEach((el) => {
                                    if (el.value) {
                                      setListOfDropDown((pre) => {
                                        pre[4].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  if (selectedDates != null) {
                                    setListOfDropDown((pre) => {
                                      pre[1].select = true;
                                      return [...pre];
                                    });
                                  }
                                  if (each.label === "None") {
                                    setSelectedListDropDown([]);
                                    setListOfDropDown((pre) => {
                                      pre = pre.map((m) => ({
                                        ...m,
                                        select: false,
                                      }));
                                      pre[0].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectDates.startDate === "" ||
                                      selectDates.endDate === ""
                                    ) {
                                      setListOfDropDown((pre) => {
                                        pre[1].select = false;
                                        return [...pre];
                                      });
                                    }
                                    salescheckBox.forEach((el) => {
                                      el.value = false;

                                      setListOfDropDown((pre) => {
                                        pre[2].select = false;
                                        return [...pre];
                                      });
                                    });
                                    projectcheckBox.forEach((el) => {
                                      el.value = false;

                                      setListOfDropDown((pre) => {
                                        pre[3].select = false;
                                        return [...pre];
                                      });
                                    });
                                    statuscheckBox.forEach((el) => {
                                      el.value = false;

                                      setListOfDropDown((pre) => {
                                        pre[4].select = false;
                                        return [...pre];
                                      });
                                    });
                                    setShowSalesValues(false);
                                    setShowDates(false);
                                    setShowprojectValues(false);
                                    setShowStatusValues(false);
                                    setSelectedSales([]);
                                    setSelectedProjects([]);
                                    setSelectedStatus([]);
                                    setSelectedDate(null);
                                    setSelectDates((pre) => {
                                      pre[0].value = "";
                                      pre[1].value = "";
                                      return { ...pre };
                                    });
                                  }
                                  if (each.label === "Sales") {
                                    setShowSalesValues(true);
                                    setShowDates(false);
                                    setShowprojectValues(false);
                                    setShowStatusValues(false);
                                  } else if (each.label === "Status") {
                                    setShowStatusValues(true);
                                    setShowSalesValues(false);
                                    setShowDates(false);
                                    setShowprojectValues(false);
                                  } else if (each.label === "Date") {
                                    setShowDates(true);
                                    setShowSalesValues(false);
                                    setShowprojectValues(false);
                                    setShowStatusValues(false);
                                  } else if (each.label === "Project") {
                                    setShowprojectValues(true);
                                    setShowSalesValues(false);
                                    setShowDates(false);
                                    setShowStatusValues(false);
                                  }
                                }}
                              >
                                <span> {each.label}</span>

                                {each.select && (
                                  <img
                                    src={checked}
                                    alt={"checked"}
                                    // style={{ marginRight: "2rem" }}
                                  />
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className={cssClasses.wrapperCheckbox}>
                        {showSalesValues &&
                          salescheckBox.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      "& .MuiTypography-root": {
                                        fontFamily: "Inter-Medium !important",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: "1.6rem !important",
                                        lineHeight: "2.4rem !important",
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: "#101828",
                                        textTransform: "capitalize",
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    if (e.target.checked) {
                                      setSalesCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedSales.push(each.id);
                                        return [...pre];
                                      });
                                    } else {
                                      setSalesCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedSales(
                                        selectedSales.filter(
                                          (id) => id !== each.id
                                        )
                                      );
                                    }
                                    let checkSalesSelected =
                                      salescheckBox.filter(
                                        ({ value }) => value === true
                                      );
                                    if (checkSalesSelected.length > 0) {
                                      setListOfDropDown((pre) => {
                                        pre[2].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === "Sales"
                                        ) === undefined
                                      ) {
                                        setSelectedListDropDown((pre) => {
                                          console.log("pre: ", pre);
                                          return [...pre, "Sales"];
                                        });
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[2].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown((pre) => [
                                        ...pre.filter(
                                          (value) => value !== "Sales"
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}
                        {showprojectValues &&
                          projectcheckBox.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      "& .MuiTypography-root": {
                                        fontFamily: "Inter-Medium !important",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: "1.6rem !important",
                                        lineHeight: "2.4rem !important",
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: "#101828",
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setProjectCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedProjects.push(each.label);
                                        return [...pre];
                                      });
                                    } else {
                                      setProjectCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedProjects(
                                        selectedProjects.filter(
                                          (label) => label !== each.label
                                        )
                                      );
                                    }
                                    let checkProjectSelected =
                                      projectcheckBox.filter(
                                        ({ value }) => value === true
                                      );
                                    if (checkProjectSelected.length > 0) {
                                      setListOfDropDown((pre) => {
                                        pre[3].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === "Project"
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push("Project");
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[3].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown([
                                        ...selectedListDropDown.filter(
                                          (value) => value !== "Project"
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}
                        {showStatusValues &&
                          statuscheckBox.map((each, index) => {
                            return (
                              <FormGroup>
                                <FormControlLabel
                                  sx={[
                                    {
                                      "& .MuiTypography-root": {
                                        fontFamily: "Inter-Medium !important",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: "1.6rem !important",
                                        lineHeight: "2.4rem !important",
                                        /* identical to box height, or 150% */

                                        /* Gray/900 */

                                        color: "#101828",
                                      },
                                    },
                                  ]}
                                  checked={each.value}
                                  onChange={(e) => {
                                    console.log(e.target.checked);
                                    if (e.target.checked) {
                                      setStatusCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        selectedStatus.push(each.label);
                                        return [...pre];
                                      });
                                    } else {
                                      setStatusCheckbox((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      setSelectedStatus(
                                        selectedStatus.filter(
                                          (status) => status !== each.label
                                        )
                                      );
                                    }
                                    let checkStatusSelected =
                                      statuscheckBox.filter(
                                        ({ value }) => value === true
                                      );
                                    if (checkStatusSelected.length > 0) {
                                      setListOfDropDown((pre) => {
                                        pre[4].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === "Status"
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push("Status");
                                      }
                                    } else {
                                      setListOfDropDown((pre) => {
                                        pre[4].select = false;
                                        return [...pre];
                                      });
                                      setSelectedListDropDown([
                                        ...selectedListDropDown.filter(
                                          (value) => value !== "Status"
                                        ),
                                      ]);
                                    }
                                  }}
                                  control={
                                    <Checkbox
                                      sx={{
                                        "& .MuiSvgIcon-root": {
                                          fontSize: 28,
                                        },
                                      }}
                                    />
                                  }
                                  label={each.label}
                                />
                              </FormGroup>
                            );
                          })}
                        {showDates && (
                          <div>
                            <div className={cssClasses.dateDivider}>
                              <div
                                className={cssClasses.label}
                                style={{ marginBottom: "0.5rem" }}
                              >
                                Start Date
                              </div>
                              <DateComponent
                                value={selectDates[0].value}
                                minDate={"1 Jan"}
                                onChangeDate={(value) => {
                                  console.log(value);
                                  setSelectedDate("notNull");
                                  setSelectDates((pre) => {
                                    pre[0].value = value;
                                    return { ...pre };
                                  });
                                  setHelperText((pre) => {
                                    pre.endDate = "";
                                    return { ...pre };
                                  });
                                }}
                                helperText={helperText.startDate}
                              ></DateComponent>
                            </div>
                            <div>
                              <div
                                className={cssClasses.label}
                                style={{ marginBottom: "0.5rem" }}
                              >
                                End Date
                              </div>
                              <DateComponent
                                value={selectDates[1].value}
                                minDate={"1 Jan"}
                                onChangeDate={(value) => {
                                  setSelectedDate("notNull");
                                  console.log(selectDates[0].value, value);
                                  if (selectDates[0].value === "") {
                                    setHelperText((pre) => {
                                      pre.endDate =
                                        "Please select start date first";
                                      return { ...pre };
                                    });
                                  } else {
                                    if (selectDates[0].value > value) {
                                      setHelperText((pre) => {
                                        pre.endDate =
                                          "Select End Date Greater than start Date";
                                        return { ...pre };
                                      });
                                    } else {
                                      setSelectDates((pre) => {
                                        pre[1].value = value;
                                        return { ...pre };
                                      });
                                      setHelperText((pre) => {
                                        pre.endDate = "";
                                        return { ...pre };
                                      });
                                      setListOfDropDown((pre) => {
                                        pre[1].select = true;
                                        return [...pre];
                                      });
                                      if (
                                        selectedListDropDown.find(
                                          (value) => value === "Date"
                                        ) === undefined
                                      ) {
                                        selectedListDropDown.push("Date");
                                      }
                                    }
                                  }
                                }}
                                helperText={helperText.endDate}
                              ></DateComponent>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className={cssClasses.wrapperDropDownButtons}>
                      <div>
                        <Button
                          style={{
                            color: "#344054",
                            backgroundColor: "#ffffff",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          padding={"0.8rem"}
                          btnName={"Clear"}
                          clicked={() => {
                            setSelectedListDropDown([]);
                            setListOfDropDown((pre) => {
                              pre = pre.map((m) => ({
                                ...m,
                                select: false,
                              }));
                              pre[0].select = true;
                              return [...pre];
                            });
                            setProjectCheckbox((pre) => {
                              pre = pre.map((m) => ({
                                ...m,
                                value: false,
                              }));
                              return [...pre];
                            });
                            setSalesCheckbox((pre) => {
                              pre = pre.map((m) => ({
                                ...m,
                                value: false,
                              }));
                              return [...pre];
                            });
                            setStatusCheckbox((pre) => {
                              pre = pre.map((m) => ({
                                ...m,
                                value: false,
                              }));
                              return [...pre];
                            });
                            setSelectedDate(null);
                            setSelectDates((pre) => {
                              pre[0].value = "";
                              pre[1].value = "";
                              return { ...pre };
                            });
                            setHelperText((pre) => {
                              pre.startDate = "";
                              pre.endDate = "";
                              return { ...pre };
                            });
                            setShowprojectValues(false);
                            setShowSalesValues(false);
                            setShowDates(false);
                            setShowStatusValues(false);
                            setSelectedSales([]);
                            setSelectedProjects([]);
                            setSelectedStatus([]);
                            Network.getStatus().then((status) => {
                              if (status.connected) {
                                getAllLeads(
                                  0,
                                  [],
                                  [],
                                  [],
                                  selectDates,
                                  null,
                                  search,
                                  drpDownSelectedVal
                                );
                              } else {
                                offlineToast();
                              }
                            });
                          }}
                        />
                      </div>
                      <div>
                        <Button
                          style={{
                            color: "#ffffff",
                            backgroundColor: "#1570EF",
                            fontSize: "1.4rem",
                            lineHeight: "2rem",
                          }}
                          padding={"0.8rem"}
                          btnName={"Apply"}
                          clicked={() => {
                            if (
                              selectDates[1].value === "" &&
                              selectedDates !== null
                            ) {
                              setHelperText((pre) => {
                                pre.endDate = "Please Select end Date";
                                return { ...pre };
                              });
                              setShowDates(true);
                            } else {
                              setHelperText((pre) => {
                                pre.endDate = "";
                                return { ...pre };
                              });
                              setShowDates(false);
                            }
                            setShowprojectValues(false);
                            setShowSalesValues(false);

                            setShowStatusValues(false);
                            if (
                              helperText.startDate === "" &&
                              helperText.endDate === ""
                            ) {
                              Network.getStatus().then((status) => {
                                if (status.connected) {
                                  if (status.connected) {
                                    getAllLeads(
                                      0,
                                      selectedSales,
                                      selectedProjects,
                                      selectedStatus,
                                      selectDates,
                                      selectedDates,
                                      search,
                                      drpDownSelectedVal
                                    );
                                  } else {
                                    offlineToast();
                                  }
                                }
                              });
                              setShowDropDown(false);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              )}
            </div>
          </div>
          <div className={cssClasses.wrapperSortDropDown}>
            {/* <div>Filter By</div> */}
            <DropDown
              list={[
                "Name Ascending",
                "Name Descending",
                "Latest First",
                "Oldest First",
              ]}
              selectedValue={drpDownSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownSelectedVal(_value);
                Network.getStatus().then((status) => {
                  if (status.connected) {
                    getAllLeads(
                      0,
                      selectedSales,
                      selectedProjects,
                      selectedStatus,
                      selectDates,
                      selectedDates,
                      search,
                      _value
                    );
                  } else {
                    offlineToast();
                  }
                });
              }}
              placeHolder={"Select"}
              //style.color is placeHolder's color
              style={{ background: "#F2F4F7", color: "rgb(102, 112, 133)" }}
              helperText={""}
            />
          </div>
        </div>
        <div className={cssClasses.wrapperSearchBar}>
          <SearchBar
            id={"leadSearch"}
            placeholder={"Search"}
            search={debouncedFetchSearchData}
            width="100%"
          />
        </div>
      </div>
      <div
        className={cssClasses.wrapperTable}
        // onScroll={onScroll}
        // ref={scrollRef}
        id="scrollableDiv"
      >
        {leadsPresent === true && (
          <InfiniteScroll
            dataLength={AllLeads.length}
            next={getMoreData}
            style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
            hasMore={loadingStatus === 0}
            scrollableTarget="scrollableDiv"
            // endMessage={
            // <p className={cssClasses.infiniteScrollLoadingText}>
            //   {(AllLeads.length > 5) && <b>Yay! You have seen it all notification</b>}
            // </p>
            // }
            refreshFunction={refreshLeads}
            pullDownToRefresh
            pullDownToRefreshThreshold={50}
            pullDownToRefreshContent={
              <h3 style={{ textAlign: "center" }}>
                &#8595; Pull down to refresh
              </h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: "center" }}>
                &#8593; Release to refresh
              </h3>
            }
          >
            {AllLeads &&
              leadsPresent &&
              uniqBy(AllLeads, "leadId").map((data) => (
                <LeadCard
                  data={data}
                  key={data.leadDisplayId}
                  returnButtonResp={buttonResp}
                />
              ))}
          </InfiniteScroll>
        )}
        {leadsPresent === false && (
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt="No Leads" />
            </div>
            <div className={cssClasses.emptyTitle}>No Leads added</div>
            {loggedInUser.cpType !== "Entity" && (
              <div className={cssClasses.emptySubTitle}>
                To add a new lead, click on
                <div className={cssClasses.addLeadBtn}>
                  <Button
                    style={{
                      color: "#fff",
                      backgroundColor: "#175CD3",
                      fontSize: "1.6rem",
                      lineHeight: "2.4rem",
                    }}
                    btnName={"Add Leads"}
                    clicked={() => {
                      setAddLeadModal(true);
                    }}
                    btnIcon={<PlusIcon />}
                    iconPosition={"left"}
                  ></Button>
                </div>
                {/* to add a new Lead */}
              </div>
            )}
          </div>
        )}
      </div>
      {addLeadModal && (
        <AddLead
          open={addLeadModal}
          handleClose={() => {
            setAddLeadModal(false);
          }}
          returnRespButton={leadAdded}
        />
      )}
    </div>
  );
}
